import React from "react";
import { Link } from "react-router-dom";
import {
  contactDetails,
  primaryNavigation,
  studioIdentity,
} from "../../data/site";
import "./Footer.css";

/**
 * Site footer.
 *
 * Opens with the wordmark set as large as the viewport allows, clipped at the
 * baseline so it reads as a mark rather than a heading, then a three-column
 * meta block and a bottom rule carrying the copyright.
 *
 * @returns {JSX.Element}
 */
function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" id="footer">
      <div className="shell">
        {/* ------------------------------------------------- oversized mark */}
        <div className="site-footer__mark" data-reveal="rise" aria-hidden="true">
          <span className="site-footer__mark-lead">
            {studioIdentity.wordmarkLead}
          </span>
          <span className="site-footer__mark-tail">
            {studioIdentity.wordmarkTail}
          </span>
        </div>

        {/* ------------------------------------------------------- meta grid */}
        <div className="site-footer__grid">
          <div className="site-footer__column">
            <h2 className="t-label site-footer__column-title">Studio</h2>
            <p className="site-footer__statement">
              {studioIdentity.tagline}
              <br />
              {studioIdentity.location}
            </p>
            {studioIdentity.foundedYear ? (
              <p className="t-meta site-footer__founded">
                Od {studioIdentity.foundedYear}
              </p>
            ) : null}
          </div>

          <nav className="site-footer__column" aria-label="Podnožje navigacija">
            <h2 className="t-label site-footer__column-title">Navigacija</h2>
            <ul role="list" className="site-footer__links">
              {primaryNavigation.map((navigationItem) => (
                <li key={navigationItem.href}>
                  <Link className="site-footer__link" to={navigationItem.href}>
                    {navigationItem.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer__column">
            <h2 className="t-label site-footer__column-title">Kontakt</h2>
            <ul role="list" className="site-footer__links">
              <li>
                <a
                  className="site-footer__link"
                  href={`mailto:${contactDetails.emailAddress}`}
                >
                  {contactDetails.emailAddress}
                </a>
              </li>
              <li>
                <a
                  className="site-footer__link"
                  href={`tel:${contactDetails.telephoneHref}`}
                >
                  {contactDetails.telephoneDisplay}
                </a>
              </li>
            </ul>

            <address className="site-footer__address t-meta">
              {contactDetails.streetAddress}
              <br />
              {contactDetails.postalCode} {contactDetails.city}
              <br />
              {contactDetails.country}
            </address>
          </div>
        </div>

        {/* ------------------------------------------------------ bottom rule */}
        <div className="site-footer__base">
          <p className="site-footer__legal t-meta">
            © {currentYear} {studioIdentity.name}. Sva prava zadržana.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
